"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryString;

function getQueryString() {
  return window.location.search;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hubspot-plugin-common/static-1.186/js/getQueryString.js
// module id = 367
// module chunks = 5 6 7